<app-page-header></app-page-header>
<app-breadcromb pageName="Account Activation"></app-breadcromb>
<!-- Login Area Start -->
<section class="jobguru-login-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="login-box">
          <div class="login-title">
            <h6>Thanks for your registration, verification code was sent to your email, please enter the verification code here to activate your account.
              If you did not receive it please check your spam folder. Do contact us when you can’t find the confirmation mail.</h6>

          </div>
          <form [formGroup]="activateAccountForm" (ngSubmit)="activateAccount()">
            <div class="single-login-field">
              <input type="text" formControlName="verificationCode" placeholder="Verification code">
              <div class="text-danger" *ngIf="a.verificationCode.touched && a.verificationCode.invalid">
                <span *ngIf="a.verificationCode.errors.required">Verification code is required</span>
              </div>

              <div class="text-danger" *ngIf="a.verificationCode.touched && a.verificationCode.invalid">
                <span *ngIf="a.verificationCode.errors.minLength">Minimum length is 6 digits</span>
              </div>
              <div class="text-danger" *ngIf="a.verificationCode.touched && a.verificationCode.invalid">
                <span *ngIf="a.verificationCode.errors.maxLength">Maximum length is 6 digits</span>
              </div>

            </div>

            <div class="single-login-field">
              <button [disabled]="activateAccountForm.invalid" class="btn btn-primary btn-xs" type="submit">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                Activate Account
              </button>
              <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
              <div *ngIf="success" class="alert alert-success mt-3 mb-0">{{success}}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Login Area End -->
